import { useRole } from '@/hooks/use-role';
import { useFreelancerProfile } from '@/lib/hooks/use-freelancer-profile';

/**
 * Convenience hook for accessing the current user's own freelancer profile
 * This provides backward compatibility for components that were using useFreelancerProfile()
 */
export function useOwnFreelancerProfile() {
  const { freelancerProfileId } = useRole();
  return useFreelancerProfile(freelancerProfileId, { enableMutations: true });
}